<template>
    <auth-layout>
        <header-page title="Riwayat"/>
        <loading-block v-if="loading" />
        <div class="riwayat-page" v-else>
            <div v-for="item in data" v-bind:key="item._id">
                <riwayat-card :color="item.type === 'redeem_verif' ? 'green' : 'orange'" :read="false" :date="item.c_date" :text="item.ket"/>
                <hr/>
            </div>
            <div class="row">
                <div class="col-6"><button type="submit" class="btn btn-primary main-button pill-button" @click="prevPage" :disabled="current_page === 1">Sebelumnya</button></div>
                <div class="col-6"><button type="submit" class="btn btn-primary main-button pill-button" @click="nextPage" :disabled="!next_page_url">Berikutnya</button></div>
            </div>
        </div>
    </auth-layout>
</template>
<style scoped>
.riwayat-page {
    padding: 0 5%;
}
</style>
<script>
import axios from "axios";

export default {
    data() {
        return {
            data: [],
            loading: true,
            current_page: 1,
            per_page: '',
            last_page: '',
            to: '',
            total: '',
            next_page_url: ''
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData (page = 1) {
            const token = this.$cookies.get('token');
            axios.get(`/api/activity?page=${page}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.data = response.data.data
                    this.current_page = response.data.current_page
                    this.per_page = response.data.per_page
                    this.last_page = response.data.last_page
                    this.to = response.data.to
                    this.total = response.data.total
                    this.next_page_url = response.data.next_page_url
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        nextPage() {
            const page = this.current_page + 1;
            this.getData(page)
            window.scrollTo(0,0);
        },
        prevPage() {
            const page = this.current_page - 1;
            this.getData(page)
            window.scrollTo(0,0);
        }
    }
}
</script>
